import React, { useContext, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { id } from '../../../../filters/options/order-date';
import DateRangePicker from '../../../components/date-range-picker';
import Global from '../../../../store/global-selectors';

import { AdvancedSearchOrderContext } from '../../context';
import messages from './messages';

import baseStyle from '../../../style.module.less';

const OrderDateFilter = () => {
  const dateFormat = useSelector(Global.selectUserUserDateFormat);
  const { filters, updateFilter } = useContext(AdvancedSearchOrderContext);
  const { value: orderDates = {} } = filters.find((filter) => filter.id === id) || {};

  const updateDateFilter = useCallback(
    (dates) => {
      updateFilter(id, dates);
    },
    [updateFilter],
  );

  const { from = null, to = null } = orderDates;

  return (
    <span className={baseStyle.filterInput}>
      <label className={baseStyle.filterLabel}>
        <FormattedMessage {...messages.orderDate} />
      </label>
      <DateRangePicker dateFormat={dateFormat} from={from} setDates={updateDateFilter} to={to} />
    </span>
  );
};

export default OrderDateFilter;
